<template>
  <el-form
    v-loading.fullscreen.lock="fullscreenLoading"
    ref="formMachinerie"
    :rules="rules"
    :model="model"
    label-position="top"
    class="padding-20"
    @submit.native.prevent="onSubmit">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item
          label="Tipo"
          prop="type">
          <el-select
            v-model="model.type"
            style="width: 100%"
            placeholder="Seleccione un tipo"
            @change="mountedBrans">
            <el-option
              v-for="(type, index) in types"
              :key="index"
              :label="type.name"
              :value="type.name"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="Marca"
          prop="brand">
          <el-autocomplete
            v-model="model.brand"
            :fetch-suggestions="fetchBrands"
            style="width: 100%"
            placeholder="Escriba una marca"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="Modelo"
          prop="model">
          <el-autocomplete
            v-model="model.model"
            :fetch-suggestions="fetchModels"
            style="width: 100%"
            placeholder="Escriba el modelo"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item
          label="Año"
          prop="year">
          <el-date-picker
            v-model="model.year"
            :picker-options="optionsPicker"
            style="width: 100%"
            type="year"
            placeholder="Selecciona un año"/>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="HP"
          prop="powerRange">
          <el-select
            v-model="model.hpMotor"
            style="width: 100%"
            placeholder="Seleccione una rango">
            <el-option
              v-for="(range, index) in powerRangeCatalog"
              :key="index"
              :label="range.label"
              :value="range.value"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="Tracción"
          prop="traction">
          <el-select
            v-model="model.traction"
            style="width: 100%"
            placeholder="Seleccione una modelo">
            <el-option
              v-for="(traction, index) in tractionCatalog"
              :key="index"
              :label="traction.label"
              :value="traction.value"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item
          label="No. Serie"
          prop="serialNumber">
          <el-input
            v-model="model.serialNumber"
            placeholder="No. Serie"/>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          label="Usado"
          prop="secondhand">
          <el-switch v-model="model.secondhand"/>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          :rules="{ required: rule, message: 'La oportunidad es requerida' }"
          label="Oportunidad"
          prop="opportunityId">
          <el-select
            v-model="model.opportunityId"
            style="width: 100%"
            placeholder="Elija una oportunidad">
            <el-option
              v-for="(opportunity, index) in opportunities"
              :key="index"
              :label="opportunity.title"
              :value="opportunity.id"/>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Fecha de compra"
          prop="acquisitionDate">
          <el-date-picker
            v-model="model.acquisitionDate"
            :picker-options="pickerOptions"
            placeholder="Seleccione una fecha"
            style="width: 100%;"/>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Tipo de compra"
          prop="saleType">
          <el-radio-group v-model="model.saleType">
            <el-radio label="CASH">De Contado</el-radio>
            <el-radio label="CREDIT">Credito</el-radio>>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Tipo de Apoyo"
          prop="supportType">
          <el-select
            v-model="model.supportType"
            style="width: 100%"
            placeholder="Seleccione una modelo">
            <el-option
              v-for="(support, index) in supportCatalog"
              :key="index"
              :label="support.label"
              :value="support.value"/>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col
        v-if="model.supportType === 'OTHER'"
        :span="12">
        <el-form-item
          label="Nombre del apoyo"
          prop="supportName">
          <el-input
            v-model="model.supportName"
            placeholder="Nombre del apoyo"/>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item
          label="Porcentaje de Crédito"
          prop="supportPorcent">
          <el-slider
            v-model="model.supportPercent"
            :step="5"/>
          {{ model.supportPercent + '%' }}
        </el-form-item>
      </el-col>
    </el-row>
    <el-row
      type="flex"
      justify="end">
      <el-col :span="8">
        <el-form-item>
          <el-button
            type="primary"
            native-type="submit">
            Guardar
          </el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import Machinerie from '@/models/machineries/machineries-model'
import { mapActions } from 'vuex'
import http from '@/services/http.service'
import moment from 'moment'
export default {
  name: 'MachineriesForm',
  props: {
    old: {
      type: Object,
      default () {
        return {}
      }
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      brandSelected: '',
      model: Machinerie.model(),
      rules: Machinerie.rules(),
      tractionCatalog: Machinerie.tractionCatalog,
      supportCatalog: Machinerie.supportCatalog,
      powerRangeCatalog: Machinerie.powerRangeCatalog,
      brands: [],
      types: [],
      models: [],
      fullscreenLoading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      optionsPicker: {
        disabledDate (time) {
          let hoy = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
          return time.getTime() > hoy
        }
      }
    }
  },
  computed: {
    rule () {
      if (this.model.secondhand) {
        return false
      }
      return true
    },
    opportunities () {
      return this.$store.getters['opportunities/items']
    }
  },
  mounted () {
    this.$store.dispatch('opportunities/query', {
      'filters[where][customerId][eq]': this.customer.id,
      limit: 1000
    })
    if (this.old !== null) {
      this.model = Object.assign({}, this.model, this.old)
    } else {
      this.model.saleType = 'CREDIT'
      http
        .get(`${process.env.API_URL}machinery-types`)
        .then(response => {
          this.types = response.data.items
        }).catch(error => {
          return Promise.reject(error)
        })
    }
  },
  methods: {
    ...mapActions('machineries', ['save']),
    ...mapActions('clientsMachineries', {'saveMachineries': 'save'}),
    fetchBrands (queryString, cb) {
      let results = []
      http.get('machinery-types', {params: {
        'filters[where][name][eq]': this.model.type
      }}).then(({data}) => {
        http.get('brands', {params: {
          'filters[where][type][eq]': data.items[0].name,
          'filters[where][name][contains]': queryString,
          limit: 1000
        }}).then(({data}) => {
          for (let item of data.items) {
            results.push({
              label: item.name,
              value: item.name
            })
          }
          cb(results)
        })
      })
    },
    fetchModels (queryString, cb) {
      let results = []
      http.get('brands', {params: {
        'filters[where][name][eq]': this.model.brand
      }}).then(({data}) => {
        http.get('models', {params: {
          'filters[where][brandId][eq]': data.items[0].id,
          'filters[where][name][contains]': queryString,
          limit: 1000
        }}).then(({data}) => {
          for (let item of data.items) {
            results.push({
              label: item.name + ' HP' + item.power,
              value: item.name
            })
          }
          cb(results)
        })
      })
    },
    onSubmit () {
      this.$refs['formMachinerie'].validate((valid) => {
        if (valid) {
          this.model.customerId = parseInt(this.customer.id)
          this.model.year = moment(this.model.year).year()
          this.save(this.model).then(response => {
            this.$store.dispatch('machineries/query', {
              'filters[where][customerId][eq]': this.customer.id
            })
              .then(({data}) => {
                this.$store.dispatch('app/toggleTractorPanel')
                this.$message.success('La maquinaria se guardo con exito')
                return this.$router.push({ ...this.$route, name: 'customers-tractors-table' })
              })
          }).catch(error => {
            this.$notify.error({
              group: 'app',
              title: 'Error al crear la maquinaria.',
              message: 'Por favor, vuelve a intentarlo.'
            })
            return Promise.reject(error)
          })
          this.fullscreenLoading = true
          setTimeout(() => {
            this.fullscreenLoading = false
          }, 2000)
        } else {
          this.$notify.error({
            group: 'app',
            title: 'Verifica el formulario.',
            message: 'Por favor, revisa los errores que se indican dentro del formulario.'
          })
          return false
        }
      })
    },
    mountedModels () {
      http
        .get(`${process.env.API_URL}brands?filters[where][name][eq]=${this.model.brand}&limit=1000`)
        .then(response => {
          http
            .get(`${process.env.API_URL}models?filters[where][brandId][eq]=${response.data.items[0].id}&limit=1000`)
            .then(response => {
              response.data.items.forEach((item) => {
                this.models.push(item)
              })
            }).catch(error => {
              return Promise.reject(error)
            })
        }).catch(error => {
          return Promise.reject(error)
        })
    },
    mountedBrans () {
      http
        .get(`${process.env.API_URL}brands?filters[where][type][eq]=${this.model.type}&limit=1000`)
        .then(response => {
          this.brands = response.data.items
        }).catch(error => {
          return Promise.reject(error)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.el-button {
  background-color: $primary;
  color: #ffffff;
  width: 100%;
  box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/modules/machineries/machineries-form.vue